// Автоимя live-записи: сохранённая запись → тема от локальной модели → новый заголовок.
//
// Запускается фоном уже ПОСЛЕ того, как запись легла в историю, поэтому не бросает:
// любой отказ — это null и прежний заголовок «Запись с микрофона ДД.ММ.ГГ ЧЧ-ММ».
//
// Заголовок и текст берутся из самой записи, а не пересобираются из состояния live:
// buildStreamingHistoryItem проставляет дату по new Date(), и повторный вызов дал бы
// другое время, чем стоит в сохранённой записи.
import { pickTitleInput, composeTitle, canRename } from './autoTitle';
import { PASTED_SOURCE_NAME } from './manualText';

/**
 * Переименовывает запись истории по её содержимому. Возвращает новый заголовок
 * или null, если менять нечего (короткий текст, молчание модели, запись уже
 * переименовали вручную, сбой сети).
 */
export async function renameRecording(recordId, { history, titles }) {
  try {
    const saved = await history.get(recordId);
    if (!canRename(saved?.title)) return null;     // чужое имя — модель не тревожим

    // Вставленный текст уже целиком на руках — треть от него была бы обрезанием
    // без причины; у живой записи треть берётся потому, что остальное дописывалось.
    const whole = saved?.title === PASTED_SOURCE_NAME;

    const input = pickTitleInput(saved?.transcript, { whole });
    if (!input) return null;                       // короткая запись — модель не тревожим

    const title = composeTitle(await titles.suggestTitle(input), saved?.title);
    if (!title) return null;

    await history.patch(recordId, { title });
    return title;
  } catch (_) {
    return null;
  }
}
